import { createBrowserRouter, Navigate } from 'react-router';
import { ROUTES } from '@/constants';
import { RootLayout } from './root';
import { RequireAnonymous, RequireAuth } from './guard';
import { RouteError } from './error';
import { LoginPage } from './login/page';
import { DashboardPage } from './dashboard/page';
import { LogsPage } from './logs/page';
import { CrashesPage } from './crashes/page';
import { IssuesPage } from './issues/page';
import { TicketsPage } from './tickets/page';
import { TicketPage } from './tickets/detail';
import { ReleasesPage } from './releases/page';
import { ReleasePage } from './releases/detail';
import { DeploymentsPage } from './deployments/page';
import { SettingsPage } from './settings/page';

/**
 * The route tree.
 *
 * Guards are layout routes rather than per-page checks: a new page added under
 * RequireAuth is protected because of where it sits, not because someone
 * remembered to wrap it. Same reasoning as the server composing its auth chain
 * once per surface.
 *
 * Unlike the admin console, `/` redirects to a real dashboard rather than to a
 * list. An operations console is opened to find out whether anything is wrong,
 * and that question deserves an answer rather than a table.
 */
export const router = createBrowserRouter([
  {
    errorElement: <RouteError />,
    children: [
      {
        element: <RequireAnonymous />,
        children: [{ path: ROUTES.login, element: <LoginPage /> }],
      },
      {
        element: <RequireAuth />,
        children: [
          {
            element: <RootLayout />,
            children: [
              { path: ROUTES.home, element: <Navigate to={ROUTES.dashboard} replace /> },
              { path: ROUTES.dashboard, element: <DashboardPage /> },
              { path: ROUTES.logs, element: <LogsPage /> },
              { path: ROUTES.crashes, element: <CrashesPage /> },
              { path: ROUTES.tickets, element: <TicketsPage /> },
              { path: ROUTES.ticket, element: <TicketPage /> },
              { path: ROUTES.issues, element: <IssuesPage /> },
              { path: ROUTES.versions, element: <ReleasesPage initialTab="builds" /> },
              { path: ROUTES.releases, element: <ReleasesPage /> },
              { path: ROUTES.release, element: <ReleasePage /> },
              { path: ROUTES.deployments, element: <DeploymentsPage /> },
              { path: ROUTES.settings, element: <SettingsPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <RouteError /> },
    ],
  },
]);
